import React, { useEffect, useState } from 'react';
import { Button, Modal, Alert, Row, Col, Image, Typography, Space } from 'antd';
import { CheckOutlined } from "@ant-design/icons";
import SampleDataService from "services/sample_data"
import _ from "lodash"
const { Paragraph, Text } = Typography;
const service = new SampleDataService();
const defaultTheme = { colorPalette: { name: "blue" } };
const ThemeSetting = ({ value, onChange }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [products, setProducts] = useState([]);
    const [selected, setSelected] = useState([])
    const [theme, setTheme] = useState({ ...defaultTheme })
    useEffect(() => {
        if (value) {
            setTheme(value)
        } else {
            setTheme({ ...defaultTheme })
        }

    }, [value])


    useEffect(() => {
        loadData();
    }, [])

    useEffect(() => {
        if (_.isArray(value)) {
            setSelected(value);
        } else {
            setSelected([])
        }
    }, [value])

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const loadData = async () => {
        var data = await service.getProducts();
        setProducts(data);
    }
    const productClick = id => {

        var isSelect = selected.includes(id);
        var newSelect = [...selected];

        if (isSelect) {
            newSelect = newSelect.filter(x => x != id);
        } else {
            newSelect.push(id);
        }
        setSelected(newSelect);
        onChange(newSelect)
    }

    const handleSelectAll = () => {
        onChange(products.map(x => x.id));
        handleOk();
    }



    const colorPalettes = [
        { name: "blue", color: "#4299e1" },

        { name: "gray", color: "#cbd5e0" },
        { name: "red", color: "#f56565" },
        { name: "orange", color: "#ed8936" },
        { name: "yellow", color: "#ecc94b" },
        { name: "green", color: "#48bb78" },
        { name: "teal", color: "#38b2ac" },

        { name: "cyan", color: "#90cdf4" },
        { name: "gray", color: "#cbd5e0" },
        { name: "purple", color: "#9f7aea" },
        { name: "pink", color: "#ed64a6" },
    ]

    const colorPaletteChange = (color) => {
        var newTheme = { ...theme, colorPalette: color };
        setTheme(newTheme);
        onChange(newTheme);
    }


    return (
        <>
            <Space direction='horizontal' wrap>

                {colorPalettes.map(x => {
                    return <div onClick={e => colorPaletteChange(x)} style={{ width: 32, height: 32, backgroundColor: x.color, display: "flex", justifyContent: "center", borderRadius: 4 }}>
                        {theme.colorPalette?.name == x.name &&
                            <CheckOutlined style={{ color: "white" }}></CheckOutlined>
                        }

                    </div>
                })}
            </Space>

        </>
    );
};
export default ThemeSetting;